module.exports = __webpack_public_path__ + "media/assets/images/category/MovieSpoofs@2x-9b2c4cb36798b7acb2d258aebdacc8ee.png";